<!-- 為使 Datatable 能以獨立版面程現，所以將他拆成component -->
<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        small
        color="primary"
        v-on="on"
      >
        {{ $t('TrainingClient.SubordinateInternalProposalForms') }}
      </v-btn>
    </template>
    <s-internal-proposal-data @closeDialog="dialog = false" />
  </v-dialog>
</template>

<script>
import SInternalProposalData from './SInternalProposalData.vue'

export default {
  components: {
    SInternalProposalData
  },
  data () {
    return {
      dialog: false
    }
  }
}
</script>
